<template>
    <div class="deploy-backup-container">
        <div class="img-container">
            <img src="/static/images/backup_deploy.png" alt="backup icon">
        </div>

        <vertical-steps :steps="steps"></vertical-steps>

        <app-button v-if="showDoneButton" @click="close" type="primary">Done</app-button>
    </div>
</template>

<script>
import VerticalSteps from "../../../components/Steps/VerticalSteps";
import {STEP_STATUS_SUCCESS} from "../../../components/Steps/VerticalSteps";
import {STEP_STATUS_FAILED} from "../../../components/Steps/VerticalSteps";
import {STEP_STATUS_CURRENT} from "../../../components/Steps/VerticalSteps";

export default {
    components: {
        VerticalSteps,
    },
    props: {
        backupFileName: {type: String, required: true},
        regions: {type: Object, required: true},
    },
    data() {
        return {
            backupName: '',
            progress: {},
            showDoneButton: false
        };
    },
    computed: {
        steps() {
            let stepsCounter = 1;
            let stepsList = [];

            for (let region in this.regions) {
                stepsList.push({
                    number: stepsCounter,
                    title: 'Deploy ' + this.regions[region].name,
                    caption: this.regions[region].url,
                    status: this.progress[stepsCounter],
                });
                stepsCounter++;
            }

            return stepsList;
        }
    },
    mounted() {
        this.runBackupDeployment();
    },
    methods: {
        async runBackupDeployment() {
            let stepsCounter = 1;

            this.$set(this.progress, stepsCounter, STEP_STATUS_CURRENT);

            try {
                await axios.post(
                    this.route('library.backups.local-deploy', {'libraryBackupFileName': this.backupFileName})
                );
                this.$set(this.progress, stepsCounter, STEP_STATUS_SUCCESS);
            } catch (Error) {
                this.$set(this.progress, stepsCounter, STEP_STATUS_FAILED);
            }

            this.showDoneButton = true;
        },
        close(e) {
            e.preventDefault();
            e.stopPropagation();

            this.$emit('close');
        }
    }
};
</script>

<style lang="scss" scoped>
.deploy-backup-container {
    margin: 0.75rem;

    & > div.img-container {
        margin: 0.75rem;
        display: flex;
        justify-content: center;
        align-items: center;

        & > img {
            width: 100px;
        }
    }

    & > button {
        margin-top: 0.75rem;
    }
}
</style>
